export const mapDataForBackend = (contactInfo) => ({
  description: `${contactInfo.description} | Kontakt via: ${contactInfo.phoneNumber || contactInfo.email}`,
});
  
